// extracted by mini-css-extract-plugin
module.exports = {"messageBody":"generic-message_messageBody__1rZqb"};